function loadScripts() {

    window.consolto = false;
    // Load Consolto chat widget after everything else
    var el = document.createElement('script');
    el.src = 'https://client.consolto.com/iframeApp/iframeApp.js';
    el.id = 'et-iframe';
    el.async = true;
    el.setAttribute('data-widgetId', '67a7024d4ab2001a985d82ef');
    el.setAttribute('data-version', '0.5');
    el.setAttribute('data-test', 'false');
    document.body.appendChild(el);

    loadCSS("//beautygarage.com/cdn/shop/t/59/assets/cart-toast-and-count.css?v=85709608548188515051783237342");

    loadScriptAsync("//beautygarage.com/cdn/shop/t/59/assets/cart-toast-and-count.js?v=44612401984727002661783237342");

  // Clean up event listeners (if needed)
  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Add event listeners for user interactions
document.addEventListener('mouseover', loadScripts);
document.addEventListener('click', loadScripts);
document.addEventListener('scroll', loadScripts);

// Helper function to dynamically load a JavaScript file
function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.defer = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

// NEW: Helper function to dynamically load a JavaScript file with async
function loadScriptAsync(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true; // Use async instead of defer
  document.head.appendChild(script);
}

function loadScriptWithDelay(src, delay) {
  setTimeout(() => {
    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }, delay);
}

// Helper function to dynamically load a CSS file
function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
